import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';

import { checkAuth } from './actions/sessionActions';

import Units from 'views/Units';
import UnitsAdd from 'views/UnitsAdd';
import UnitsDetail from 'views/UnitsDetail';
import CooperativesAdd from 'views/CooperativesAdd'
import CooperativesDetail from 'views/CooperativesDetail';
import Charts from 'views/Charts';
import Updates from 'views/Updates';
import Models3D from 'views/Models3D';
import Models3DDetail from 'views/Models3DDetail';
import Models3DAdd from 'views/Models3DAdd';
import Equipments from 'views/Equipments';
import Nir from 'views/Nir';
import EquipmentsQL from 'views/EquipmentsQL';
import EquipmentsAdd from 'views/EquipmentsAdd';
import EquipmentsTelemetria from 'views/EquipmentsTelemetria';
import EquipmentsDetail from 'views/EquipmentsDetail';
import EquipmentsDetailQL from 'views/EquipmentsDetailQL';
import Users from 'views/Users';
import UsersDetail from 'views/UsersDetail';
import Settings from 'views/Settings';
import Home from 'views/Home';
import Notifications from 'views/Notifications';
import Relatorio from 'views/Relatorio';
import UserPassword from 'views/UsersPassword';
import Cooperatives from 'views/Cooperatives';
import Suporte from 'views/Suporte';
import Conected from 'views/Suporte/components/Conected';
import SuporteNir from 'views/SuporteNir';
import ConectedNir from 'views/SuporteNir/components/ConectedNir';
import ConectedDry from 'views/SuporteDry/components/ConectedDry';
import SuporteDry from 'views/SuporteDry';
import EquipmentsReplace from 'views/EquipmentsReplace';
import SuporteOrange from 'views/SuporteOrange';
import SuporteIot from 'views/SuporteIot';
import ConectedOrange from 'views/SuporteOrange/components/ConectedOrange';
import ConectedIot from 'views/SuporteIot/components/ConectedIot';
import ServerLocal from 'views/ServerLocal';
import ServerLocalDetail from 'views/ServerLocalDetail';
import Assistencias from 'views/Assistencias';
import AssistenciasDetail from 'views/Assistencias/AssistenciasDetail';
import MapsHub from 'views/MapsHub';
import Logs from 'views/Logs';
import Logout from 'views/Logout';
import PainelExecutivo from 'views/PainelExecutivo/PainelExecutivo';
import AnalyticsDashboard from 'views/AnalyticsDashboard';
import UpdatesCharts from 'views/UpdatesCharts';
import AssistenciasCertificados from 'views/AssistenciasCertificados';
import AssistenciasAdd from 'views/AssistenciasAdd';
import AssistenciasComprarSenhas from 'views/AssistenciasComprarSenhas';
import AssistenciasCadastros from 'views/AssistenciasCadastros';

const routes = [
  {
    path: '/',
    exact: true,
    render: () =>
      checkAuth() ? <Redirect to="/home" /> : <Redirect to="/auth/login" />
  },
  {
    path: '/logout',
    exact: true,
    component: Logout
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('views/Login'))
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/home',
        exact: true,
        render: (props) =>
          checkAuth() ? <Home {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/painel-executivo',
        exact: true,
        render: (props) =>
          checkAuth() ? <PainelExecutivo {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/analytics',
        exact: true,
        render: (props) =>
          checkAuth() ? <AnalyticsDashboard {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/users',
        exact: true,
        render: (props) =>
          checkAuth() ? <Users {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/userspassword',
        exact: true,
        render: (props) =>
          checkAuth() ? <UserPassword {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/logs',
        exact: true,
        render: (props) =>
          checkAuth() ? <Logs {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/maps',
        exact: true,
        render: (props) =>
          checkAuth() ? <MapsHub {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/maps-calibration',
        exact: true,
        render: () =>
          checkAuth() ? <Redirect to="/maps?tab=calibration" /> : <Redirect to="/auth/login" />
      },
      {
        path: '/maps-units',
        exact: true,
        render: () =>
          checkAuth() ? <Redirect to="/maps?tab=units" /> : <Redirect to="/auth/login" />
      },
      {
        path: '/maps-measures',
        exact: true,
        render: () =>
          checkAuth() ? <Redirect to="/maps?tab=measures" /> : <Redirect to="/auth/login" />
      },
      {
        path: '/maps-tracking',
        exact: true,
        render: () =>
          checkAuth() ? <Redirect to="/maps?tab=tracking" /> : <Redirect to="/auth/login" />
      },
      {
        path: '/charts',
        exact: true,
        render: (props) =>
          checkAuth() ? <Charts {...props} /> : <Redirect to="/auth/login" />
      },

      {
        path: '/charts-atualizacoes',
        exact: true,
        render: (props) =>
          checkAuth() ? <UpdatesCharts {...props} /> : <Redirect to="/auth/login" />
      },

      {
        path: '/updates',
        exact: true,
        render: (props) =>
          checkAuth() ? <Updates {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/models-3d',
        exact: true,
        render: (props) =>
          checkAuth() ? <Models3D {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/models-3d/viewer/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <Models3DDetail {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/models-3d/add',
        exact: true,
        render: (props) =>
          checkAuth() ? <Models3DAdd {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/units',
        exact: true,
        render: (props) =>
          checkAuth() ? <Units {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/units/add',
        exact: true,
        render: (props) =>
          checkAuth() ? <UnitsAdd {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/units/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <UnitsDetail {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/support',
        exact: true,
        render: (props) =>
          checkAuth() ? <Suporte {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/support/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <Conected {...props} /> : <Redirect to="/auth/login" />
      },

      {
        path: '/supportnir',
        exact: true,
        render: (props) =>
          checkAuth() ? <SuporteNir {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/supportnir/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <ConectedNir {...props} /> : <Redirect to="/auth/login" />
      },

      {
        path: '/supportdry',
        exact: true,
        render: (props) =>
          checkAuth() ? <SuporteDry {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/supportdry/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <ConectedDry {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/supportiot',
        exact: true,
        render: (props) =>
          checkAuth() ? <SuporteIot {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/supportiot/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <ConectedIot {...props} /> : <Redirect to="/auth/login" />
      },

      {
        path: '/remote-access',
        exact: true,
        render: (props) =>
          checkAuth() ? <SuporteOrange {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/remote-access/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <ConectedOrange {...props} /> : <Redirect to="/auth/login" />
      },

      {
        path: '/cooperatives',
        exact: true,
        render: (props) =>
          checkAuth() ? <Cooperatives {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/cooperatives/add',
        exact: true,
        render: (props) =>
          checkAuth() ? <CooperativesAdd {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/cooperatives/:id',
        exact: true,
        render: (props) =>
          checkAuth() ?
            <CooperativesDetail {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/equipments',
        exact: true,
        render: (props) =>
          checkAuth() ? <Equipments {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/nir',
        exact: true,
        render: (props) =>
          checkAuth() ? <Nir {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/nir/:serial',
        exact: true,
        render: () =>
          checkAuth() ? <Redirect to="/nir" /> : <Redirect to="/auth/login" />
      },
      {
        path: '/equipments/add',
        exact: true,
        render: (props) =>
          checkAuth() ? <EquipmentsAdd {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/equipments/telemetria',
        exact: true,
        render: (props) =>
          checkAuth() ? <EquipmentsTelemetria {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/equipments/:serial',
        exact: true,
        render: (props) =>
          checkAuth() ? <EquipmentsDetail {...props} /> : <Redirect to="/auth/login" />
      },

      {
        path: '/server-local',
        exact: true,
        render: (props) =>
          checkAuth() ? <ServerLocal {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/server-local/:serial',
        exact: true,
        render: (props) =>
          checkAuth() ? <ServerLocalDetail {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/equipmentsQL',
        exact: true,
        render: (props) =>
          checkAuth() ? <EquipmentsQL {...props} /> : <Redirect to="/auth/login" />
      },

      {
        path: '/equipments-replace',
        exact: true,
        render: (props) =>
          checkAuth() ? <EquipmentsReplace {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/relatorio',
        exact: true,
        render: (props) =>
          checkAuth() ? <Relatorio {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/equipmentsQL/:serial',
        exact: true,
        render: (props) =>
          checkAuth() ? <EquipmentsDetailQL {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/painel-assistencias',
        exact: true,
        render: (props) =>
          checkAuth() ? <Assistencias {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/certificados',
        exact: true,
        render: (props) =>
          checkAuth() ? <AssistenciasCertificados {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/cadastros',
        exact: true,
        render: (props) =>
          checkAuth() ? <AssistenciasCadastros {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/assistencias/add',
        exact: true,
        render: (props) =>
          checkAuth() ? <AssistenciasAdd {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/assistencias/edit/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <AssistenciasAdd {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/senhas',
        exact: true,
        render: (props) =>
          checkAuth() ? <AssistenciasComprarSenhas {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/assistencias',
        exact: true,
        render: (props) =>
          checkAuth() ? <Assistencias {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/assistencias/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <AssistenciasDetail {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/notifications',
        exact: true,
        render: (props) =>
          checkAuth() ? <Notifications {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/users/:id',
        exact: true,
        render: (props) =>
          checkAuth() ? <UsersDetail {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/settings',
        exact: true,
        render: (props) =>
          checkAuth() ? <Settings {...props} /> : <Redirect to="/auth/login" />
      },
      {
        path: '/settings/:tab',
        exact: true,
        render: (props) =>
          checkAuth() ? <Settings {...props} /> : <Redirect to="/auth/login" />
      },
    ]
  }
];

export default routes;
